import createPostingPreview from '../views/nominal/NominalPostingPreviewForm';
import { IFormAction } from '../@types/entityTypes';
import React, { ReactNode, useCallback, useContext, useState } from 'react';
import ConnectedFormContext from '../components/Context/ConnectedFormContext';
import { usePerformSave } from '../components/connectedForm/Hooks/usePerformSave';
import { Modal } from '@fluentui/react';

export const usePreviewPostingsAction = <ActionType,>({
  actionReference,
  individualButton,
  postingPreview: PostingPreview,
}: {
  actionReference: ActionType;
  individualButton: boolean;
  postingPreview: ReturnType<typeof createPostingPreview>;
}): [action: IFormAction<ActionType>, modals: ReactNode] => {
  const { values } = useContext(ConnectedFormContext);
  const [performSave, confirmationPrompt] = usePerformSave();
  const [previewOpen, setPreviewOpen] = useState(false);
  const previewPostingsModal = (
    <Modal isOpen={previewOpen} onDismiss={() => setPreviewOpen(false)}>
      <PostingPreview match={{ params: { id: values?.id } }} onClose={() => setPreviewOpen(false)} />
    </Modal>
  );

  const displayPreview = useCallback((record: any) => {
    if (record?.documentStatus) {
      return record.documentStatus === 'DRAFT' || record.documentStatus === 'RELEASED';
    }
    return false;
  }, []);

  return [
    {
      actionReference: actionReference,
      key: 'previewPostings',
      text: 'Preview Postings',
      onClick: () =>
        performSave({
          submitMeta: { suppressAfterSubmit: true },
          onSaveComplete: () => {
            setPreviewOpen(true);
          },
        }),
      individualButton: individualButton,
      condition: displayPreview,
      iconProps: { iconName: 'save' },
    },
    <>
      {previewPostingsModal}
      {confirmationPrompt}
    </>,
  ];
};
